import { __, prop, pipe, defaultTo } from 'ramda';

import colors from './colors';

const getColor = pipe(prop(__, colors), defaultTo('#000000'));

export const palette = Object.freeze({
  primary: getColor('gold'),
  primaryOpacity: getColor('gold-opacity'),
  secondary: getColor('gold-dark'),
  neutral: getColor('gold-neutral'),
  light: getColor('gold-light'),
  selected: getColor('aqua'),

  cancelled: getColor('red-fade'),
  confirmed: getColor('green'),
  requested: getColor('yellow'),
  pending: getColor('warm-green'),

  warning: getColor('yellow'),
  error: 'red',
  ok: 'green',

  sectionLabel: getColor('gray-label'),
  link: {
    default: getColor('gold-dark'),
    active: getColor('gold'),
  },

  navigation: getColor('whiteish'),
  listSeparatorColor: getColor('gold'),
  opacity: 0.35,
});

export const boxShadows = Object.freeze({
  default: '4px 4px 8px 0 rgba(0,0,0,0.1)',
});

export const borders = Object.freeze({
  default: getColor('gray-dark'),
  medium: getColor('gray-medium'),
  normal: getColor('gray'),
  range: getColor('gold-border'),
  secondary: getColor('gray-secondary'),
});

export const backgrounds = Object.freeze({
  default: getColor('white'),
  defaultOpacity: getColor('white-opacity-1'),
  whiteOpacity: getColor('white-opacity-2'),
  secondary: getColor('whiteish'),
  light: getColor('gray-light'),
});

export const spacing = Object.freeze({
  gutter: 10,
  unit: 'px',
});

export const sizes = Object.freeze({
  borderRadius: 1,

  headerSizes: {
    mobile: 70,
    tablet: 120,
  },
});

export const animations = Object.freeze({
  defaultTransition: 'ease-in-out 0.25s all',
});

export const theme = {
  palette,
  borders,
  backgrounds,
  spacing,
  sizes,
  animations,
  boxShadows,
}
